import { IndividualType } from '../../../types/Individual'

/**
 * Returns the full name where possible (firstName + familyName).
 * Only falls back to preferredName if first/family name are both empty.
 * Optionally includes title at the start.
 */
export function getFullName (individual: IndividualType, title: boolean = false): string {
  const parts: Array<string | null | undefined> = []

  if (individual.firstName) {
    parts.push(individual.firstName)
  }
  if (individual.familyName) {
    parts.push(individual.familyName)
  }
  if (parts.length > 0) {
    if (title) {
      parts.unshift(individual.title)
    }
  } else if (individual.preferredName) {
    parts.push(individual.preferredName)
  }

  return parts.filter((item) => item).join(' ')
}
